import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SharedService } from '../../providers/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sm-qr-codes',
  templateUrl: './qr-codes.component.html',
  styleUrls: ['./qr-codes.component.scss']
})
export class QrCodesComponent implements OnInit {
  clickEventSubscription: Subscription;
  constructor(private _navService: NavigationService, private sharedService: SharedService) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
  }

  ngOnInit(): void {


  }

  ngOnDestroy(): void {
    this.clickEventSubscription.unsubscribe()
  }

}
